import { Footer, PublicNavbar } from "../";

import { Outlet } from "@tanstack/react-router";
import { ReactNode } from "react";
import { CookieDialog } from "../../cookie";

type TPublicLayoutProps = {
  children?: ReactNode;
};

export function PublicLayout({ children }: TPublicLayoutProps) {
  return (
    <main className="flex min-h-dvh flex-col">
      <PublicNavbar />
      <div className="flex-1">
        {children ?? <Outlet />}
      </div>
      <Footer />
      <CookieDialog />
    </main>
  );
}
